var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { Box } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached';
import CustomButton from '../../../components/buttonComponent/CustomButton';
import ConfirmationAndInformationPoup, { POPUP_TYPE, } from '../../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { MultiRecordFormTabs, useDynamicFormOverrides, } from '../../../components/FormComponents/dynamicForm';
import constants from '../../../config/constants';
import { utility } from '../../../utils';
import { BILLING_ADDRESS_FIELD_NAMES, buildCustomerSections, CREATE_APPLICATION_STEP_ID, CUSTOMER_ASPIRE_FIELD, CUSTOMER_FIELD, CUSTOMER_LOOKUP_KEY, CUSTOMER_SEARCH_KEY, CUSTOMER_SECTION_ID, deriveCustomerValues, getCustomerRecordLabel, GUARANTOR_ASPIRE_FIELD, SIGNER_GUARANTOR_ALWAYS_EDITABLE_FIELD_NAMES, SIGNER_GUARANTOR_FIELD_NAMES, SIGNER_GUARANTOR_MATCHED_CONTACT_FIELD, } from '../config/create_application_schema';
import { createCustomerTaxIdLookup, createLegalNameSearch, } from '../customer_lookup_service';
import { signerGuarantorTaxIdLookup } from '../guarantor_lookup_service';
import { fetchLocCustomerPrefill } from '../schedule_takedown_service';
import { AUTOFILL_SOURCE_KEY, deleteAutofillDocument, uploadAutofillDocument, } from '../autofill_service';
import { useExistingContactSlots } from './ExistingContactSelection';
import OcrExtractionBanner from './OcrExtractionBanner';
import SmartAutofillBanner from './SmartAutofillBanner';
var AUTOFILL_SOURCES = [
    { key: AUTOFILL_SOURCE_KEY.Invoice, label: 'Invoice/Sales Order' },
    { key: AUTOFILL_SOURCE_KEY.DriverLicense, label: "Driver's License" },
];
var AUTOFILL_SOURCE_SENTENCE_LABEL = [
    [AUTOFILL_SOURCE_KEY.DriverLicense, 'Driving license'],
    [AUTOFILL_SOURCE_KEY.Invoice, 'Sales order/Invoice'],
];
var PRIMARY_CUSTOMER_INDEX = 0;
var SIGNER_FIELD_NAMES = {
    contactAspireOId: CUSTOMER_ASPIRE_FIELD.SignerContactAspireOId,
    firstName: CUSTOMER_FIELD.SignerFirstName,
    middleName: CUSTOMER_FIELD.SignerMiddleName,
    lastName: CUSTOMER_FIELD.SignerLastName,
    suffix: CUSTOMER_FIELD.SignerSuffix,
    title: CUSTOMER_FIELD.SignerTitle,
    email: CUSTOMER_FIELD.SignerEmail,
    phone: CUSTOMER_FIELD.SignerPhone,
};
var answeredFieldNames = function (values) {
    var answered = Object.keys(values).filter(function (fieldName) {
        var value = values[fieldName];
        return value !== '' && value !== null && value !== undefined;
    });
    if (BILLING_ADDRESS_FIELD_NAMES.some(function (name) { return answered.includes(name); })) {
        return answered;
    }
    return answered.filter(function (name) { return name !== CUSTOMER_FIELD.BillingSameAsMain; });
};
var UNREADABLE_DOCUMENT_MESSAGE = 'Nothing could be read from that document. Please check it is the right one, or fill the form in by hand.';
var REMOVE_FAILED_MESSAGE = 'That document could not be removed. Please try again.';
var shiftRecordIndexMap = function (map, removedIndex) {
    return Object.entries(map).reduce(function (next, _a) {
        var key = _a[0], value = _a[1];
        var index = Number(key);
        if (index !== removedIndex) {
            next[index > removedIndex ? index - 1 : index] = value;
        }
        return next;
    }, {});
};
var CustomerInformationStep = React.forwardRef(function (_a, ref) {
    var onAutofillDocument = _a.onAutofillDocument, onAutofillDocumentRemove = _a.onAutofillDocumentRemove, autofillContext = _a.autofillContext, onDraftApplicationId = _a.onDraftApplicationId, isDriverLicenseAutofillEnabled = _a.isDriverLicenseAutofillEnabled, isSmartAutofillEnabled = _a.isSmartAutofillEnabled, isCanadaProgram = _a.isCanadaProgram, canAddCustomers = _a.canAddCustomers, _b = _a.locTxAspireOId, locTxAspireOId = _b === void 0 ? '' : _b, collectsGuarantor = _a.collectsGuarantor, isConsumerProgram = _a.isConsumerProgram;
    var recordsRef = React.useRef(null);
    var _c = React.useState(false), isResetPopupOpen = _c[0], setIsResetPopupOpen = _c[1];
    var _d = React.useState(false), hasPrefilledDetails = _d[0], setHasPrefilledDetails = _d[1];
    var markPrefilled = React.useCallback(function (result) {
        if (result) {
            setHasPrefilledDetails(true);
        }
        return result;
    }, []);
    var isCustomerInherited = Boolean(locTxAspireOId);
    var _e = useExistingContactSlots({
        recordsRef: recordsRef,
        sectionId: CUSTOMER_SECTION_ID.AuthorizedSigner,
        signerFields: SIGNER_FIELD_NAMES,
    }), beginContactsReport = _e.beginContactsReport, startContactsForRecord = _e.startContactsForRecord, getSectionSlots = _e.getSectionSlots, clearContacts = _e.clearContacts;
    var _f = React.useState({}), lockedFieldsByRecord = _f[0], setLockedFieldsByRecord = _f[1];
    React.useEffect(function () {
        if (!locTxAspireOId) {
            return undefined;
        }
        var isCancelled = false;
        fetchLocCustomerPrefill(locTxAspireOId, isConsumerProgram).then(function (prefill) {
            var _a;
            var _b;
            if (isCancelled || !prefill) {
                return;
            }
            (_b = recordsRef.current) === null || _b === void 0 ? void 0 : _b.mergeActiveRecord(prefill.values);
            startContactsForRecord(PRIMARY_CUSTOMER_INDEX, prefill.contacts);
            setLockedFieldsByRecord((_a = {},
                _a[PRIMARY_CUSTOMER_INDEX] = answeredFieldNames(prefill.values),
                _a));
        });
        return function () {
            isCancelled = true;
        };
    }, [isConsumerProgram, locTxAspireOId, startContactsForRecord]);
    var getLockedFieldNames = React.useCallback(function (recordIndex) { return lockedFieldsByRecord[recordIndex]; }, [lockedFieldsByRecord]);
    var _g = React.useState(false), isPrimaryCustomerFromExisting = _g[0], setIsPrimaryCustomerFromExisting = _g[1];
    var matchConfirmResolveRef = React.useRef(null);
    var _h = React.useState(false), isMatchConfirmationOpen = _h[0], setIsMatchConfirmationOpen = _h[1];
    var confirmMatch = React.useCallback(function () {
        var _a;
        (_a = matchConfirmResolveRef.current) === null || _a === void 0 ? void 0 : _a.call(matchConfirmResolveRef, false);
        return new Promise(function (resolve) {
            matchConfirmResolveRef.current = resolve;
            setIsMatchConfirmationOpen(true);
        });
    }, []);
    var resolveMatchConfirmation = React.useCallback(function (confirmed) {
        var _a;
        (_a = matchConfirmResolveRef.current) === null || _a === void 0 ? void 0 : _a.call(matchConfirmResolveRef, confirmed);
        matchConfirmResolveRef.current = null;
        setIsMatchConfirmationOpen(false);
    }, []);
    var removeConfirmResolveRef = React.useRef(null);
    var _j = React.useState(false), isRemoveConfirmationOpen = _j[0], setIsRemoveConfirmationOpen = _j[1];
    var confirmRemoveCustomer = React.useCallback(function () {
        var _a;
        (_a = removeConfirmResolveRef.current) === null || _a === void 0 ? void 0 : _a.call(removeConfirmResolveRef, false);
        return new Promise(function (resolve) {
            removeConfirmResolveRef.current = resolve;
            setIsRemoveConfirmationOpen(true);
        });
    }, []);
    var resolveRemoveConfirmation = React.useCallback(function (confirmed) {
        var _a;
        (_a = removeConfirmResolveRef.current) === null || _a === void 0 ? void 0 : _a.call(removeConfirmResolveRef, confirmed);
        removeConfirmResolveRef.current = null;
        setIsRemoveConfirmationOpen(false);
    }, []);
    var handleRecordRemoved = React.useCallback(function (recordIndex) {
        setLockedFieldsByRecord(function (previous) { return shiftRecordIndexMap(previous, recordIndex); });
        setGuarantorBlockMatchedRecords(function (previous) {
            return shiftRecordIndexMap(previous, recordIndex);
        });
    }, []);
    var _k = React.useState(null), resetSignerGuarantorRecordIndex = _k[0], setResetSignerGuarantorRecordIndex = _k[1];
    var _l = React.useState({}), guarantorBlockMatchedRecords = _l[0], setGuarantorBlockMatchedRecords = _l[1];
    var noteSignerGuarantorMatch = React.useCallback(function (recordIndex) {
        if (recordIndex === undefined || recordIndex === null) {
            return;
        }
        setGuarantorBlockMatchedRecords(function (previous) {
            var _a;
            return (__assign(__assign({}, previous), (_a = {}, _a[recordIndex] = true, _a)));
        });
    }, []);
    var handleResetSignerGuarantorDetails = React.useCallback(function (recordIndex) {
        var _a;
        var blankValues = {};
        SIGNER_GUARANTOR_FIELD_NAMES.forEach(function (fieldName) {
            blankValues[fieldName] = '';
        });
        __spreadArray(__spreadArray([], Object.values(GUARANTOR_ASPIRE_FIELD), true), Object.values(SIGNER_GUARANTOR_MATCHED_CONTACT_FIELD), true).forEach(function (fieldName) {
            blankValues[fieldName] = '';
        });
        (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.mergeRecord(recordIndex, blankValues);
        setLockedFieldsByRecord(function (previous) {
            var _a;
            var _b;
            var stillLocked = ((_b = previous[recordIndex]) !== null && _b !== void 0 ? _b : []).filter(function (fieldName) { return !SIGNER_GUARANTOR_FIELD_NAMES.includes(fieldName); });
            return __assign(__assign({}, previous), (_a = {}, _a[recordIndex] = stillLocked, _a));
        });
        setGuarantorBlockMatchedRecords(function (previous) {
            var next = __assign({}, previous);
            delete next[recordIndex];
            return next;
        });
        setResetSignerGuarantorRecordIndex(null);
    }, []);
    var lockAnsweredFields = React.useCallback(function (values, recordIndex) {
        if (recordIndex === undefined || recordIndex === null) {
            return;
        }
        var newlyAnswered = answeredFieldNames(values);
        if (newlyAnswered.length === 0) {
            return;
        }
        setLockedFieldsByRecord(function (previous) {
            var _a;
            var _b;
            return (__assign(__assign({}, previous), (_a = {}, _a[recordIndex] = Array.from(new Set(__spreadArray(__spreadArray([], ((_b = previous[recordIndex]) !== null && _b !== void 0 ? _b : []), true), newlyAnswered, true))), _a)));
        });
    }, []);
    var noteIfPrimaryExistingCustomerMatch = React.useCallback(function (values, recordIndex) {
        if (recordIndex === PRIMARY_CUSTOMER_INDEX &&
            values[CUSTOMER_ASPIRE_FIELD.IsFromExistingCustomer]) {
            setIsPrimaryCustomerFromExisting(true);
        }
    }, []);
    var lookupHandlers = React.useMemo(function () {
        var _a;
        return (_a = {},
            _a[CUSTOMER_LOOKUP_KEY.ExistingCustomerByTaxId] = function (taxId, values) { return __awaiter(void 0, void 0, void 0, function () {
                var recordIndex, result;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            recordIndex = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.getActiveRecordIndex();
                            return [4, createCustomerTaxIdLookup(beginContactsReport, isConsumerProgram, confirmMatch)(taxId, values)];
                        case 1:
                            result = _b.sent();
                            if (result) {
                                lockAnsweredFields(result, recordIndex);
                                noteIfPrimaryExistingCustomerMatch(result, recordIndex);
                            }
                            return [2, markPrefilled(result)];
                    }
                });
            }); },
            _a[CUSTOMER_LOOKUP_KEY.ExistingSignerGuarantorByTaxId] = function (taxId, values) { return __awaiter(void 0, void 0, void 0, function () {
                var recordIndex, matched, lockableValues;
                var _a;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            recordIndex = (_b = recordsRef.current) === null || _b === void 0 ? void 0 : _b.getActiveRecordIndex();
                            return [4, signerGuarantorTaxIdLookup(taxId, values)];
                        case 1:
                            matched = _c.sent();
                            if (!matched) {
                                return [2, null];
                            }
                            lockableValues = Object.fromEntries(Object.entries(matched).filter(function (_a) {
                                var fieldName = _a[0];
                                return !SIGNER_GUARANTOR_ALWAYS_EDITABLE_FIELD_NAMES.includes(fieldName);
                            }));
                            lockAnsweredFields(lockableValues, recordIndex);
                            lockAnsweredFields((_a = {}, _a[CUSTOMER_FIELD.TaxpayerId] = taxId, _a), recordIndex);
                            noteSignerGuarantorMatch(recordIndex);
                            return [2, markPrefilled(matched)];
                    }
                });
            }); },
            _a);
    }, [
        beginContactsReport,
        confirmMatch,
        isConsumerProgram,
        lockAnsweredFields,
        markPrefilled,
        noteIfPrimaryExistingCustomerMatch,
        noteSignerGuarantorMatch,
    ]);
    var searchHandlers = React.useMemo(function () {
        var _a;
        return (_a = {},
            _a[CUSTOMER_SEARCH_KEY.ExistingCustomerByLegalName] = {
                search: function (term, values) {
                    return createLegalNameSearch(beginContactsReport, isConsumerProgram).search(term, values);
                },
                select: function (option, values) { return __awaiter(void 0, void 0, void 0, function () {
                    var recordIndex, result;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                recordIndex = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.getActiveRecordIndex();
                                return [4, createLegalNameSearch(beginContactsReport, isConsumerProgram, confirmMatch).select(option, values)];
                            case 1:
                                result = _b.sent();
                                if (result) {
                                    lockAnsweredFields(result, recordIndex);
                                    noteIfPrimaryExistingCustomerMatch(result, recordIndex);
                                }
                                return [2, markPrefilled(result)];
                        }
                    });
                }); },
            },
            _a);
    }, [
        beginContactsReport,
        confirmMatch,
        isConsumerProgram,
        lockAnsweredFields,
        markPrefilled,
        noteIfPrimaryExistingCustomerMatch,
    ]);
    var resolveSections = useDynamicFormOverrides().resolveSections;
    var getSections = React.useCallback(function (recordIndex) {
        var schemaSections = buildCustomerSections(recordIndex === PRIMARY_CUSTOMER_INDEX, isCanadaProgram, collectsGuarantor, isConsumerProgram);
        return resolveSections
            ? resolveSections(CREATE_APPLICATION_STEP_ID.CustomerInformation, schemaSections)
            : schemaSections;
    }, [collectsGuarantor, isCanadaProgram, isConsumerProgram, resolveSections]);
    React.useImperativeHandle(ref, function () { return ({
        validate: function () { var _a, _b; return (_b = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.validate()) !== null && _b !== void 0 ? _b : true; },
        getPayload: function () { var _a, _b; return ({ customers: (_b = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.getRecords()) !== null && _b !== void 0 ? _b : [] }); },
        getFiles: function () { var _a, _b; return (_b = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.getFiles()) !== null && _b !== void 0 ? _b : {}; },
        reset: function () { var _a; return (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.reset(); },
        getPreview: function () {
            var _a, _b;
            return ({
                label: 'Customer Information',
                records: ((_b = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.getRecords()) !== null && _b !== void 0 ? _b : []).map(function (values, index) { return ({
                    label: getCustomerRecordLabel(index),
                    sections: getSections(index),
                    values: values,
                }); }),
            });
        },
    }); }, [getSections]);
    var _m = React.useState({}), uploadedFileNames = _m[0], setUploadedFileNames = _m[1];
    var _o = React.useState({}), uploadedFileIds = _o[0], setUploadedFileIds = _o[1];
    var _p = React.useState(''), scanningSourceKey = _p[0], setScanningSourceKey = _p[1];
    var _q = React.useState([]), filledLabels = _q[0], setFilledLabels = _q[1];
    var _r = React.useState({}), ocrFilledValues = _r[0], setOcrFilledValues = _r[1];
    var contextRef = React.useRef(autofillContext);
    React.useEffect(function () {
        contextRef.current = __assign(__assign({}, autofillContext), contextRef.current);
    }, [autofillContext]);
    var sources = React.useMemo(function () {
        return AUTOFILL_SOURCES.filter(function (source) {
            return source.key !== AUTOFILL_SOURCE_KEY.DriverLicense ||
                isDriverLicenseAutofillEnabled;
        });
    }, [isDriverLicenseAutofillEnabled]);
    var handleAutofillSelect = React.useCallback(function (sourceKey, file) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setScanningSourceKey(sourceKey);
                    return [4, uploadAutofillDocument(sourceKey, file, contextRef.current, isConsumerProgram)];
                case 1:
                    result = _b.sent();
                    setScanningSourceKey('');
                    if (!result) {
                        utility.alert(UNREADABLE_DOCUMENT_MESSAGE, constants.TOAST_TYPES.WARN);
                        return [2];
                    }
                    if (result.applicationId) {
                        contextRef.current = __assign(__assign({}, contextRef.current), { applicationId: result.applicationId });
                        onDraftApplicationId(result.applicationId);
                    }
                    (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.mergeActiveRecord(result.values);
                    setOcrFilledValues(function (previous) { return (__assign(__assign({}, previous), result.values)); });
                    setHasPrefilledDetails(true);
                    setUploadedFileNames(function (previous) {
                        var _a;
                        return (__assign(__assign({}, previous), (_a = {}, _a[sourceKey] = result.fileName, _a)));
                    });
                    setUploadedFileIds(function (previous) {
                        var _a;
                        return (__assign(__assign({}, previous), (_a = {}, _a[sourceKey] = result.fileId, _a)));
                    });
                    setFilledLabels(function (previous) {
                        return Array.from(new Set(__spreadArray(__spreadArray([], previous, true), result.filledLabels, true)));
                    });
                    onAutofillDocument(sourceKey, file);
                    return [2];
            }
        });
    }); }, [isConsumerProgram, onAutofillDocument, onDraftApplicationId]);
    var handleAutofillRemove = React.useCallback(function (sourceKey) { return __awaiter(void 0, void 0, void 0, function () {
        var isRemoved, drop;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, deleteAutofillDocument((_a = uploadedFileIds[sourceKey]) !== null && _a !== void 0 ? _a : '')];
                case 1:
                    isRemoved = _b.sent();
                    if (!isRemoved) {
                        utility.alert(REMOVE_FAILED_MESSAGE, constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    drop = function (previous) {
                        var next = __assign({}, previous);
                        delete next[sourceKey];
                        return next;
                    };
                    setUploadedFileNames(function (previous) {
                        var remaining = drop(previous);
                        if (Object.keys(remaining).length === 0) {
                            setFilledLabels([]);
                            setOcrFilledValues({});
                        }
                        return remaining;
                    });
                    setUploadedFileIds(drop);
                    onAutofillDocumentRemove(sourceKey);
                    return [2];
            }
        });
    }); }, [onAutofillDocumentRemove, uploadedFileIds]);
    var getOcrFilledValues = React.useCallback(function (recordIndex) {
        return recordIndex === PRIMARY_CUSTOMER_INDEX ? ocrFilledValues : undefined;
    }, [ocrFilledValues]);
    var handleResetForm = React.useCallback(function () {
        var _a;
        (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.reset();
        clearContacts();
        setIsResetPopupOpen(false);
        setHasPrefilledDetails(false);
        setLockedFieldsByRecord({});
        setIsPrimaryCustomerFromExisting(false);
        setGuarantorBlockMatchedRecords({});
        Object.keys(uploadedFileIds).forEach(function (sourceKey) {
            var _a;
            deleteAutofillDocument((_a = uploadedFileIds[sourceKey]) !== null && _a !== void 0 ? _a : '');
            onAutofillDocumentRemove(sourceKey);
        });
        setUploadedFileNames({});
        setUploadedFileIds({});
        setFilledLabels([]);
        setOcrFilledValues({});
    }, [clearContacts, onAutofillDocumentRemove, uploadedFileIds]);
    var extractedDocumentLabels = React.useMemo(function () {
        return AUTOFILL_SOURCE_SENTENCE_LABEL.filter(function (_a) {
            var key = _a[0];
            return uploadedFileNames[key];
        })
            .map(function (_a) {
            var label = _a[1];
            return label;
        })
            .join(' & ');
    }, [uploadedFileNames]);
    var primarySectionHeaders = React.useMemo(function () {
        var _a;
        return isSmartAutofillEnabled
            ? (_a = {},
                _a[isConsumerProgram
                    ? CUSTOMER_SECTION_ID.IndividualDetails
                    : CUSTOMER_SECTION_ID.BusinessDetails] = (React.createElement(React.Fragment, null,
                    React.createElement(SmartAutofillBanner, { sources: sources, selectedFileNames: uploadedFileNames, scanningSourceKey: scanningSourceKey, isDisabled: isCustomerInherited || isPrimaryCustomerFromExisting, onFileSelect: handleAutofillSelect, onFileRemove: handleAutofillRemove }),
                    filledLabels.length > 0 && (React.createElement(OcrExtractionBanner, { extractedCount: filledLabels.length, documentLabels: extractedDocumentLabels, fieldLabels: filledLabels })))),
                _a) : undefined;
    }, [
        extractedDocumentLabels,
        filledLabels,
        handleAutofillRemove,
        handleAutofillSelect,
        isConsumerProgram,
        isCustomerInherited,
        isPrimaryCustomerFromExisting,
        isSmartAutofillEnabled,
        scanningSourceKey,
        sources,
        uploadedFileNames,
    ]);
    var getSectionHeaders = React.useCallback(function (recordIndex) {
        return recordIndex === PRIMARY_CUSTOMER_INDEX ? primarySectionHeaders : undefined;
    }, [primarySectionHeaders]);
    var getGroupActions = React.useCallback(function (recordIndex) {
        var _a;
        return guarantorBlockMatchedRecords[recordIndex]
            ? (_a = {},
                _a[CUSTOMER_SECTION_ID.GuarantorAdditionalDetails] = (React.createElement(CustomButton, { variant: "secondary", SMButton: true, fullWidth: false, startIcon: React.createElement(CachedIcon, { sx: { fontSize: 15 } }), onClick: function () { return setResetSignerGuarantorRecordIndex(recordIndex); } }, "Reset Form")),
                _a) : undefined;
    }, [guarantorBlockMatchedRecords]);
    return (React.createElement(Box, null,
        React.createElement(MultiRecordFormTabs, { ref: recordsRef, idPrefix: "customer", getSections: getSections, getRecordLabel: getCustomerRecordLabel, addLabel: "Add Customer", canAddRecords: canAddCustomers, confirmRemoveRecord: confirmRemoveCustomer, onRecordRemoved: handleRecordRemoved, deriveValues: deriveCustomerValues, lookupHandlers: lookupHandlers, searchHandlers: searchHandlers, getSectionHeaders: getSectionHeaders, getGroupActions: getGroupActions, getLockedFieldNames: getLockedFieldNames, getOcrFilledValues: getOcrFilledValues, getSectionSlots: getSectionSlots, trailingContent: isCustomerInherited || !hasPrefilledDetails ? undefined : (React.createElement(CustomButton, { variant: "secondary", SMButton: true, fullWidth: false, startIcon: React.createElement(CachedIcon, { sx: { fontSize: 15 } }), onClick: function () { return setIsResetPopupOpen(true); }, sx: { flexShrink: 0, mb: 0.5 } }, "Reset Form")) }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, open: isResetPopupOpen, titleText: "Reset the customer forms?", message: "Everything entered for every customer on this application will be cleared.", acceptBtnText: "Reset", acceptCallBack: handleResetForm, denyBtnText: "Cancel", denyCallBack: function () { return setIsResetPopupOpen(false); }, cancelCallBack: function () { return setIsResetPopupOpen(false); } }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, open: resetSignerGuarantorRecordIndex !== null, titleText: "Confirm Reset", message: "Are you sure you want to reset the guarantor details? All auto-populated information will be reset and you'll need to enter details again.", acceptBtnText: "Reset", acceptCallBack: function () {
                return resetSignerGuarantorRecordIndex !== null &&
                    handleResetSignerGuarantorDetails(resetSignerGuarantorRecordIndex);
            }, denyBtnText: "Cancel", denyCallBack: function () { return setResetSignerGuarantorRecordIndex(null); }, cancelCallBack: function () { return setResetSignerGuarantorRecordIndex(null); } }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, open: isRemoveConfirmationOpen, titleText: "Are you sure?", message: "This customer and any contacts or guarantor details linked to it will be removed from the application.", acceptBtnText: "Delete", acceptCallBack: function () { return resolveRemoveConfirmation(true); }, denyBtnText: "Cancel", denyCallBack: function () { return resolveRemoveConfirmation(false); }, cancelCallBack: function () { return resolveRemoveConfirmation(false); } }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, open: isMatchConfirmationOpen, titleText: "Match Found", message: "We found a match in our system. The fields below will be pre-populated with the existing customer information.", acceptBtnText: "Yes", acceptCallBack: function () { return resolveMatchConfirmation(true); }, denyBtnText: "No", denyCallBack: function () { return resolveMatchConfirmation(false); }, cancelCallBack: function () { return resolveMatchConfirmation(false); } })));
});
CustomerInformationStep.displayName = 'CustomerInformationStep';
export default CustomerInformationStep;
